import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import PolicyCard from '@/dashboard/components/Products/policyCard/index';
import PaymentScheduleView from '@/dashboard/components/indexPage/paymentSchedule';
import PaymentSummaryView from '@/dashboard/components/indexPage/paymentSummary/index';
import LogoLoading from '@/dashboard/components/loading/LogoLoading';
import HomeProductIntroductionView from '@/dashboard/components/productIntroduction/home';
import { useDisplayUserInfo } from '@/dashboard/hooks/useDisplayUserInfo';
import { useMaterialMedia } from '@/dashboard/hooks/useMaterialMedia';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import { displayUserStore } from '@/dashboard/store/displayUserStore';
import { globalDataStore } from '@/dashboard/store/globalDataStore';
import { useCountryStore, useCoverStore } from '@jove-frontend/uikit';
import { useTableView } from '@jove-frontend/uikit';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import { uniqueId } from 'lodash';
import DashboardLayout from '../layouts/DashboardLayout';
import { usePolicyStore } from '../store/PolicyStore';
import { withAuthRequired } from '../utils/withAuthRequired';

const Index = () => {
  const router = useRouter();
  const { tableList, setTableList } = useTableView();
  const [{ policies, isLoading }, { initialize }] = usePolicyStore(({ state, actions }) => [state, actions]);
  const [{ initialize: initializeCoverStore }] = useCoverStore(({ actions }) => [actions]);
  const [{ initialize: initializeCountryStore }] = useCountryStore(({ actions }) => [actions]);
  const { isMobile } = useMaterialMedia();
  const {
    actions: { updateGlobalQueryParams },
  } = globalDataStore();
  const {
    actions: { updateDisplayUserInfo },
  } = displayUserStore();
  const { displayUserInfo } = useDisplayUserInfo();
  const [queryUserId, setQueryUserId] = useState(router.query.queryUserId as string);
  const [listUniqueId, setListUniqueId] = useState(uniqueId());

  /**
   * effects
   */
  useEffect(() => {
    const { queryUserId } = router.query as any;
    if (queryUserId) {
      updateDisplayUserInfo({ userId: queryUserId });
    }
    updateGlobalQueryParams({ queryUserId });
    initialize({ queryUserId });
    initializeCoverStore();
    initializeCountryStore();
  }, []);

  useEffect(() => {
    if (policies) {
      const list = [];
      policies.forEach((item) => {
        const model = new PolicyModel();
        model.transformServeDataToInstance(item);
        list.push(model);
      });
      setListUniqueId(uniqueId());
      setTableList(list);
    }
  }, [policies]);

  return (
    <DashboardLayout className="relative">
      <div>
        {!(!!queryUserId && !displayUserInfo) && <h3 className="text-black">Welcome back {displayUserInfo?.first_name}</h3>}
        <div className={clsx('mt-10 grid grid-cols-1 items-start lg:grid-cols-3 lg:gap-8', { 'gap-4': !isMobile })}>
          {isMobile && (
            <div className="col-span-1 mb-4">
              <PaymentSummaryView />
            </div>
          )}
          <div className="col-span-2">
            <div
              className={clsx('mb-10 rounded-lg bg-black/5', {
                'px-6 py-5': !isMobile,
                'px-2 py-2': isMobile,
              })}
            >
              <PaymentScheduleView className="mb-10" />

              <Typography className="text-black-secondary font-black" variant="h5">
                Policies
              </Typography>
              <Box className="relative mt-4 flex min-h-[200px] flex-col">
                {isLoading && <LogoLoading />}
                {tableList?.map((policy) => (
                  <PolicyCard key={listUniqueId + policy.id} policy={policy} className="mb-5" />
                ))}
              </Box>
            </div>
          </div>

          {!isMobile && (
            <div className="col-span-1">
              <PaymentSummaryView />
            </div>
          )}
        </div>
        <HomeProductIntroductionView className="mt-16" />
      </div>
    </DashboardLayout>
  );
};

export default withAuthRequired(Index);
